import { render } from 'mustache';
import { Renderer } from './renderer';
import { Message } from './message';
import { Question } from '../model/question';
import { randomChoice, evalInContext } from '../utils';

interface ResponseOption {
    label: string;
    id: string;
}

@Renderer.register("question")
export class QuestionRenderer extends Renderer {
    render(element: Question, context: object): Message {
        let options = element.options.filter((option) => {
            if (option.if !== undefined) {
                return evalInContext(option.if, context) && true;
            } else {
                return true;
            }
        });

        let responses: ResponseOption[] = options.map(option => {
            let label = "";
            if (option.label instanceof Array) {
                label = render(randomChoice(option.label), context);
            } else {
                label = render(option.label, context);
            }

            return {
                label: label,
                id: option.id!
            }
        });

        return new Message("question", {
            responses: responses
        });
    }
}
